import { apiClient } from './client';
import type {
  ActivityLogFilters,
  PaginatedActivityLogs,
} from '@/types/activity-log.types';

/**
 * ActivityLogService
 * Frontend service for interacting with activity log API endpoints
 */
export class ActivityLogService {
  /**
   * Get all activities with optional filters and pagination
   */
  async getActivities(
    filters?: ActivityLogFilters,
    limit: number = 20,
    offset: number = 0
  ): Promise<PaginatedActivityLogs> {
    const params: Record<string, string> = {
      limit: limit.toString(),
      offset: offset.toString(),
    };

    if (filters?.entityType) params.entityType = filters.entityType;
    if (filters?.actionType) params.actionType = filters.actionType;
    if (filters?.actorId) params.actorId = filters.actorId.toString();
    if (filters?.startDate) params.startDate = filters.startDate;
    if (filters?.endDate) params.endDate = filters.endDate;

    const response = await apiClient.get('/activities', { params });
    return response.data;
  }

  /**
   * Get activities for a specific celebration
   */
  async getCelebrationActivities(
    celebrationId: number,
    filters?: ActivityLogFilters,
    limit: number = 20,
    offset: number = 0
  ): Promise<PaginatedActivityLogs> {
    const params: Record<string, string> = {
      limit: limit.toString(),
      offset: offset.toString(),
    };

    if (filters?.entityType) params.entityType = filters.entityType;
    if (filters?.actionType) params.actionType = filters.actionType;
    if (filters?.actorId) params.actorId = filters.actorId.toString();
    if (filters?.startDate) params.startDate = filters.startDate;
    if (filters?.endDate) params.endDate = filters.endDate;

    const response = await apiClient.get(`/celebrations/${celebrationId}/activities`, { params });
    return response.data;
  }

  /**
   * Get activities for the current user
   */
  async getUserActivities(
    filters?: ActivityLogFilters,
    limit: number = 20,
    offset: number = 0
  ): Promise<PaginatedActivityLogs> {
    const params: Record<string, string> = {
      limit: limit.toString(),
      offset: offset.toString(),
    };

    if (filters?.entityType) params.entityType = filters.entityType;
    if (filters?.actionType) params.actionType = filters.actionType;
    if (filters?.startDate) params.startDate = filters.startDate;
    if (filters?.endDate) params.endDate = filters.endDate;

    const response = await apiClient.get('/activities/my-activities', { params });
    return response.data;
  }
}

export const activityLogService = new ActivityLogService();
